import Modal from "../_bootstrapModalExtensions";
import * as Filter from '../components/filterGroup';
import * as Maintenance from '../components/processActionMaintenance';
import * as Status from '../components/processActionStatus';
import Classes from "../_classes";
import * as Url from '../Utils/UrlUtil';
import { RefreshInspectorsTable } from '../_processList';

$(() => {
    if (IsOnPage()) {
        Maintenance.Init();

        Status.Init();

        // Mivel nem lehet értelmesen buffereleni a razor kimenetét, előfordul, hogy üres a doboz, ekkor viszont eltüntetjük
        HideMaintenanceBoxWhenEmpty();
    }

    function IsOnPage(): boolean {
        return Boolean(document.getElementById('processaction-edit-page'));
    }
});

export function InitProcessActionEditTabPage() {
    Filter.Init();
}

export function RefreshTopPartial(processActionId: number) {
    $.ajax({
        url: window.ETDR_RD.appConfig["UrlAction.EditProcessActionTopPartial"],
        type: 'POST',
        data: { processActionId: processActionId },
        success: (data) => {
            $('#top-partial-wrapper').html(data);

            HideMaintenanceBoxWhenEmpty();
        }
    });
}

export function OnListClerksByOfficeForSignoffSelectionChanged(s: MVCxClientGridView, e: ASPxClientGridViewSelectionEventArgs) {
    Modal.ToggleModalSaveButtonStateByDxSelectionState(s, e);

    if (e.visibleIndex < 0) {
        return;
    }

    let selectedClerkId: string = s.GetSelectedKeysOnPage()[0];

    $('.selected-clerk-id-input-for-signoff').val(selectedClerkId);
}

export function OnListClerksByOfficeForSignOffInit(s: MVCxClientGridView, e) {
    Modal.ToggleModalSaveButtonStateByDxSelectionState(s, e);
}

function HideMaintenanceBoxWhenEmpty() {
    if ($('#maintenance-box button, #maintenance-box a').length <= 0) {
        $('#maintenance-box').hide();
    }
}

export function EditInspectorUserTimePartial(nameOrEmail: string, id: number, processId: number) {
    let modalSettings: Classes.BootstrapModalWithAjaxContentSettings = GetModalSettings();

    Modal.showBootstrapModalWithAjaxContent(modalSettings);

    function GetModalSettings(): Classes.BootstrapModalWithAjaxContentSettings {
        let settings: Classes.BootstrapModalWithAjaxContentSettings = new Classes.BootstrapModalWithAjaxContentSettings();

        const contentUrlTemplate: string = window.ETDR_RD.appConfig['UrlTemplate.GetInspectorUserTimePartial'];
        const saveUrlTemplate: string = window.ETDR_RD.appConfig['UrlTemplate.UpdateInspectorUserTime'];

        settings.title = nameOrEmail;
        settings.contentUrl = Url.createUrlFromTemplate(contentUrlTemplate, { id: id });
        settings.saveUrl = Url.createUrlFromTemplate(saveUrlTemplate, { id: id });
        settings.callback = () => {
            RefreshInspectorsTable(processId)
        };

        return settings;
    }
}

function showModalToProcessEditRedirection(event: JQuery.TriggeredEvent) {
    const modalText: string =
        'Addig nem lehet a cselekményt véglegesíteni, amíg a "Statisztika" lapon az "Adatok véglegesítése" gomb aktív. Automatikusan átirányítjuk oda, hogy javítsa.';
    const processId: number = $(event.currentTarget).data('process-id');
    const onRejectCb = () => { };

    Modal.showConfirmationWindowAsync(modalText, 'Figyelem!', onAcceptCb, onRejectCb, 'Rendben', 'Mégsem');

    function onAcceptCb(): void {
        const urlTemplate: string = window.ETDR_RD.appConfig['UrlTemplate.ProcessEditWithActiveTabSet'];
        const url: string = Url.createUrlFromTemplate(urlTemplate, { Id: processId, activeTab: 'ksh' });

        location.href = url;
    }
}

$(() => {
    $(document).on('click', '.edit-inspector-permission-period', (event: JQuery.TriggeredEvent) => {
        const $button: JQuery<HTMLElement> = $(event.target);
        const nameOrEmail = $button.data('name-or-email');
        const id = $button.data('id');
        const processId = $button.data('process-id');

        EditInspectorUserTimePartial(nameOrEmail, id, processId);
    });

    $(document).on('click', '#fake-make-absolute-btn', (event: JQuery.TriggeredEvent) => {
        showModalToProcessEditRedirection(event);
    });
});
